const WPAPI = require("wpapi");

const wp = new WPAPI({
  endpoint: window.WP.endpoint,
  nonce: window.WP.nonce,
});

// register wp-api endpoints
// console.log('wpapi blockSlug:', global[CONFIG.widgetId].blockSlug);
const blockPath = 'widgetic/' + global[CONFIG.widgetId].blockSlug;
wp.widgeticCompositions = wp.registerRoute(blockPath, "/compositions");
wp.currentUser = wp.registerRoute(blockPath, "/current_user");
wp.getSecret = wp.registerRoute(blockPath, "/secret");

module.exports = wp;
